/*
 * SPDX-FileCopyrightText: 2026 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { GuardResult, Router } from '@angular/router';
import {
  AuthRedirectService,
  AuthService,
  BaseSiteService,
  CmsService,
  ProtectedRoutesService,
  SemanticPathService
} from '@spartacus/core';
import { LogoutGuard } from '@spartacus/storefront';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UIGLogoutGuard extends LogoutGuard {
  
  constructor(
    protected auth: AuthService,
    protected cms: CmsService,
    protected semanticPathService: SemanticPathService,
    protected protectedRoutes: ProtectedRoutesService,
    protected router: Router,
    protected baseSiteService: BaseSiteService,
    protected authRedirectService: AuthRedirectService,
  ) {
    super(auth, cms, semanticPathService, protectedRoutes, router);
  }

  canActivate(): Observable<GuardResult> {
    return super.canActivate();
  }

  protected override logout(): Promise<any> {
    const homeRedirectUrl = this.getHomeRedirectUrl();
    this.authRedirectService.setRedirectUrl(homeRedirectUrl);

    return this.auth.coreLogout().then(() => {
      window.location.assign(`/${homeRedirectUrl}`);
    });
  }

  private getHomeRedirectUrl(): string {
    const segments = window.location.pathname.split('/').filter(Boolean);

    if (segments.length < 3) {
      return '';
    }

    return `${segments.slice(0, 3).join('/')}/`;
  }

}
